import { jsx as _jsx } from "react/jsx-runtime";
import Close from "@mui/icons-material/Close";
import Paper from "@mui/material/Paper";
import Slide from "@mui/material/Slide";
import Dialog from "@mui/material/Dialog";
import { colors } from "healthex-common/colors";
import { fontSizes } from "healthex-common/sizes";
import { fontWeights } from "healthex-common/weights";
import * as React from "react";
import styled from "styled-components";
import { FlexColumnDiv, FlexRowDiv } from "./common.styles";
import { mobilePageMaxWidth } from "./HXMobilePage.styles";
import IconButton from "@mui/material/IconButton";
export const SlideUpTransition = React.forwardRef((props, ref) => {
    return _jsx(Slide, { direction: "up", ref: ref, ...props });
});
export const HalfSheetDialog = styled(Dialog) `
    .MuiDialog-paper {
        border-top-left-radius: 16px;
        border-top-right-radius: 16px;
        border-bottom-left-radius: 0;
        border-bottom-right-radius: 0;
    }
`;
export const HalfSheetPaper = styled(Paper) `
    background-color: ${colors.white_main};

    && {
        margin: 0;
        width: 100%;
        max-width: ${mobilePageMaxWidth}px;
        align-self: flex-end;
        max-height: 100%;
    }
`;
export const Content = styled(FlexColumnDiv) `
    padding: 24px 24px 100px 24px;
    gap: 20px;
    align-items: stretch;
`;
export const Header = styled(FlexRowDiv) `
    align-items: flex-start;
    justify-content: space-between;
    gap: 16px;
`;
export const TitleBlock = styled(FlexColumnDiv) `
    gap: 4px;
    align-items: flex-start;
    flex: 1 1 auto;
`;
export const Title = styled.div `
    color: ${colors.black_main};
    font-size: ${fontSizes.LARGE};
    font-weight: ${fontWeights.SEMI_BOLD};
    line-height: normal;
`;
export const Subtitle = styled.div `
    color: ${colors.black_lighter};
    font-size: ${fontSizes.TINY};
    font-weight: ${fontWeights.SEMI_BOLD};
    letter-spacing: 0.5px;
    text-transform: uppercase;
`;
const CloseButtonEl = styled(IconButton) `
    width: 32px;
    height: 32px;
    border-radius: 100px;
    border: 1px solid ${colors.black_lighter};
    color: ${colors.black_lighter};

    svg {
        width: 24px;
        height: 24px;
    }
`;
export const CloseButton = (props) => {
    var _a;
    return (_jsx(CloseButtonEl, { onClick: props.onClick, "aria-label": (_a = props.ariaLabel) !== null && _a !== void 0 ? _a : "Close", children: _jsx(Close, {}) }));
};
export const Body = styled.div `
    color: ${colors.black_main};
    font-size: ${fontSizes.STANDARD};
    font-weight: ${fontWeights.NORMAL};
    line-height: 1.4;
`;
export const SectionDivider = styled(FlexRowDiv) `
    align-items: center;
    gap: 12px;
    align-self: stretch;
`;
export const SectionDividerLabel = styled(Subtitle) `
    white-space: nowrap;
`;
export const SectionDividerLine = styled.div `
    flex: 1 1 auto;
    height: 1px;
    background-color: ${colors.black_12};
`;
export const RequirementList = styled(FlexColumnDiv) `
    gap: 16px;
    align-items: stretch;
`;
export const RequirementRow = styled(FlexRowDiv) `
    align-items: flex-start;
    gap: 12px;
`;
export const RequirementIcon = styled.div `
    color: ${colors.black_light};
    flex-shrink: 0;

    svg {
        width: 24px;
        height: 24px;
    }
`;
export const RequirementText = styled(Body) ``;
export const VerifyButtonContainer = styled(FlexColumnDiv) `
    align-items: flex-end;
    padding-top: 4px;

    && > * {
        width: auto;
    }
`;
